import {mapInstructions} from './normalizeInstructions';

export const normalizeCreateInstruction = ({state, sectionId = null, instruction, isTask = false}) => {
	const newInstruction = mapInstructions(instruction, isTask);

	if (isTask) {
		return [{...state, count: state.count + 1, tasks: [...state.tasks, newInstruction]}];
	}

	return state.map((section) => {
		if (section.id === sectionId)
			return {...section, count: section.count + 1, instructions: [...section.instructions, newInstruction]};
		return section;
	});
};

export const normalizeEditInstruction = ({state, instruction, isTask = false}) => {
	const newInstruction = mapInstructions(instruction, isTask);

	if (isTask)
		return [
			{
				...state,
				tasks: state.tasks.map((task) => {
					if (task.id === newInstruction.id) return newInstruction;
					return task;
				})
			}
		];

	return state.map((section) => {
		if (section.id === instruction.sectionId)
			return {
				...section,
				instructions: section.instructions.map((instruction) => {
					if (instruction.id === newInstruction.id) return newInstruction;
					return instruction;
				})
			};
		return section;
	});
};

export const normalizeDeleteInstruction = ({state, sectionId = null, instructionId, isTask = false}) => {
	const filterIt = (i) => i.id !== instructionId;

	if (isTask) {
		return {...state, count: state.count - 1, tasks: state.tasks.filter(filterIt)};
	}

	return state.map((section) => {
		if (section.id === sectionId)
			return {...section, count: section.count - 1, instructions: section.instructions.filter(filterIt)};
		return section;
	});
};
